import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config-service/app-config.service';
import { AuthHttpClient } from '../auth-http-service/auth-http.service';
import { Patient } from '../../domain/patient';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import { RegistrationModel } from '../../models/registration-model';
import { ChangePasswordModel } from '../../models/change-password-model';


////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     24/04/2018
// Description: Authorises or deauthorsises a user access to the PHR
////-------------------------------------------------------------------------------------------

@Injectable()
export class AuthorisationService {
  changePassword(changePasswordModel:ChangePasswordModel): Observable<Response> {
    return this.http.post(this.appConfigService.ChangePassword,changePasswordModel);
  }

  constructor(private appConfigService: AppConfigService, private http: AuthHttpClient) { }

  getPatientEmail(patient: Patient): Observable<Response> {
    let emailGetUrl: string = this.appConfigService.PatientEmailGetUrl.replace('{patientId}', patient.Id.toString());
    return this.http.get(emailGetUrl);
  }

  authorise(patient: Patient, emailAddress: string): Observable<Response> {
    let authoriseUrl: string = this.appConfigService.PatientAuthorisePostUrl;
    let authorisationModel: AuthorisationModel = new AuthorisationModel(1, patient.Id, emailAddress);
    return this.http.post(authoriseUrl, JSON.stringify(authorisationModel));
  }

  deauthorise(patient: Patient): Observable<Response> {
    let deauthoriseUrl: string = this.appConfigService.PatientDeauthorisePostUrl;
    let deAuthorisationModel: DeauthorisationModel = new DeauthorisationModel(1, patient.Id);
    return this.http.post(deauthoriseUrl, JSON.stringify(deAuthorisationModel));
  }

  checkStatus(patient: Patient): Observable<Response> {
    let statusUrl: string = this.appConfigService.PatientPhrStatusUrl.replace('{patientId}', patient.Id.toString());
    return this.http.get(statusUrl);
  }

  register(registrationModel: RegistrationModel): Observable<Response> {
    let registrationUrl: string = this.appConfigService.PatientRegisterPostUrl;
    return this.http.post(registrationUrl, JSON.stringify(registrationModel));
  }

  
  reset(registrationModel: RegistrationModel): Observable<Response> {
    let resetUrl: string = this.appConfigService.PatientResetPasswordPostUrl;
    return this.http.post(resetUrl, JSON.stringify(registrationModel));
  }
}

export class AuthorisationModel {

  constructor(private accessAuthorisedBy: number, patientId: number, patientEmailAddress: string) {
    this.AccessAuthorisedById = accessAuthorisedBy;
    this.PatientEmailAddress = patientEmailAddress;
    this.PatientId = patientId;
  }

  AccessAuthorisedById: number;
  PatientId: number;
  PatientEmailAddress: string;
}

export class DeauthorisationModel {

  constructor(private accessDeauthorisedBy: number, patientId: number, ) {
    this.AccessDeauthorisedById = accessDeauthorisedBy;
    this.PatientId = patientId;
  }

  AccessDeauthorisedById: number;
  PatientId: number;
}



// WEBPACK FOOTER //
// ./src/app/services/authorisation-service/authorisation-service.service.ts